<script>

    import { LocationStore } from '../stores'
    
    import Modal from '../$components/modal.svelte'
    import Locations from '../locations/locations.svelte'
    import LocationRead from '../locations/location.svelte'
    import LocationCreate from '../locations/location.create.svelte'
    import LocationUpdate from '../locations/location.update.svelte'

</script>

<Locations />
 
<Modal id="LocationRead" title="Información" >
    <LocationRead on:deleted={LocationStore.modalClose} />
</Modal>

<Modal id="LocationCreate" title="Crear dirección" >
    <LocationCreate on:created={LocationStore.modalClose} on:canceled={LocationStore.modalClose}/>
</Modal>   

<Modal id="LocationUpdate" title="Actualizar dirección">
    <LocationUpdate on:updated={LocationStore.modalClose} on:canceled={LocationStore.modalClose}/>
</Modal>